import { useConfigSlice } from '../slices/config/selectors';

// TODO Should be renamed to Connected: https://pragmaticplay.atlassian.net/browse/UIC-764
export const useHideCurrency = (): boolean => {
  const casinoConfig = useConfigSlice.casinoConfig();
  const compliance = useConfigSlice.compliance();

  return (compliance?.hideCurrency || casinoConfig?.hideCurrency) ?? false;
};
